// extracted by mini-css-extract-plugin
export var actionText = "_pd-4";
export var container = "_pd-0";
export var leftSection = "_pd-1";
export var rightSection = "_pd-2";
export var settingsButton = "_pd-6";
export var settingsIcon = "_pd-7";
export var shortcut = "_pd-5";
export var shortcutGroup = "_pd-3";